import { Link } from 'react-router-dom';
import BlockUi from 'react-block-ui';
import { ItemStatusBadge } from '../_components/ItemStatusBadge';
import { useItemDetailsBootstrap } from './item-details.bootstrap.hook';

export default function ItemDetails() {
  const {
    itemId,
    item,
    loading,
    formatCurrency,
    parseBoolean,
    formatBenefitsType,
  } = useItemDetailsBootstrap();

  if (loading) {
    return (
      <BlockUi tag="div" blocking={true}>
        <div style={{ height: '500px' }}></div>
      </BlockUi>
    );
  }

  if (!item) return <div>Produto não encontrado.</div>;

  return (
    <div className="d-flex flex-column-fluid">
      <div className="container p-0">
        <div className="card card-custom gutter-b">
          <div className="card-header border-0 py-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">
                Detalhes do Produto
              </span>
            </h3>
            <div className="card-toolbar">
              <Link
                to={`/payments/items/${itemId}/edit`}
                className="btn add-item-form-card__btn-cancel mr-2"
              >
                Editar
              </Link>
            </div>
          </div>

          <div className="card-body pt-0 pb-10">
            <div className="mb-10">
              <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
                <span className="text-dark ">Status</span>
                <ItemStatusBadge item={item} />
              </div>

              <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
                <span className="text-dark ">Nome do produto</span>
                <span className="text-dark font-weight-bolder">
                  {item.name || '-'}
                </span>
              </div>

              <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
                <span className="text-dark ">Código do produto</span>
                <span className="text-dark font-weight-bolder">
                  {item.code || '-'}
                </span>
              </div>

              <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
                <span className="text-dark ">Valor</span>
                <span className="text-dark font-weight-bolder">
                  {formatCurrency(item.value)}
                </span>
              </div>

              <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
                <span className="text-dark ">Visível para o cliente</span>
                <span className="text-dark font-weight-bolder">
                  {parseBoolean(item.display_client) ? 'Sim' : 'Não'}
                </span>
              </div>

              <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
                <span className="text-dark ">Tipo de benefício</span>
                <span className="text-dark font-weight-bolder">
                  {formatBenefitsType(item.benefitType || item.benefits_type)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
